export function checkDocs(userData = {}, field = null) {
  const requiredFields = [
    "identityDocument",
    "insuranceDocument",
    "otherInsuranceDocument",
  ];

  // Single field mode
  if (field) {
    const value = userData[field] ?? [];
    return Array.isArray(value) && value.some(item => item.verified === true);
  }

  // All fields mode
  let allValid = true;

  requiredFields.forEach(key => {
    // Special rule: insuranceDocument OR otherInsuranceDocument
    if (key === "insuranceDocument") {
      const insuranceValue = userData["insuranceDocument"] ?? [];
      const otherInsuranceValue = userData["otherInsuranceDocument"] ?? [];
      const hasVerified =
        insuranceValue.some(item => item.verified === true) ||
        otherInsuranceValue.some(item => item.verified === true);
      if (!hasVerified) allValid = false;
      return; // skip normal check
    }

    // Skip otherInsuranceDocument because handled together
    if (key === "otherInsuranceDocument") return;

    const value = userData[key] ?? [];
    if (!Array.isArray(value) || !value.some(item => item.verified === true)) {
      allValid = false;
    }
  });

  return allValid;
}
